<template>
    <div class="history-wrapper">
        <div class="history-box flexBox">
            <section class="history-chunk base-info-chunk flexBox">
                <img class="avatar" :src="HeadImg" @error="$imgErr">
                <h3 class="base-info info-name">{{ infoName }}</h3>
                <h3 class="base-info department">{{ Department }}</h3>
            </section>
            
            <section class="history-chunk mine-items-chunk flexItem">
                <ul class="mine-items">
                    <li class="mine-item flexBox" @click="actionSeekHelp('Mine')">
                        <img class="item-icon" src="/static/images/icon/mine-seek.svg">
                        <span class="item-name flexItem">我的服务请求</span>
                        <span class="item-arrow"></span>
                    </li>
                    <li class="mine-item flexBox" @click="viewAllDailyReport">
                        <img class="item-icon" src="/static/images/icon/history-report.svg">
                        <span class="item-name flexItem">近期知识日报</span>
                        <span class="item-arrow"></span>
                    </li>
                </ul>
            </section>
        </div>
    </div>
</template>

<script>
    import commonMixin from '@/utils/commonMixin'
    export default {
        name: 'mine',
        mixins: [ commonMixin ],
        data() {
            return{

            }
        },
        methods: {
            viewAllDailyReport() {
                this.$router.push({
                    path: 'recentDailyReport'
                })
            }
        },
        computed: {
            HeadImg() {
                return localStorage.HeadImg
            },
            infoName() {
                return localStorage.EnName + ' ' + localStorage.CnName
            },
            Department() {  // 一级部门
                return localStorage.Tier1
            }
        }
    }
</script>

<style lang="scss" scoped>
    .history-wrapper {
        height: calc(100% - 2.213rem - 1.3067rem);
        padding-top: j(166);
        background-image: url('/static/images/mine-bg.jpg');
        background-color: #f7f7f8;
        background-repeat: no-repeat;
        background-size: contain;
        .history-box {
            flex-direction: column;
            height: 100%;
            padding-left: j(35);
            padding-right: j(35);
            .history-chunk {
                width: 100%;
                background: #fff;
                border-radius: j(6);
            }
        }
    }
    
    .base-info-chunk {
        flex-direction: column;
        padding-bottom: j(37);
        .avatar {
            padding: j(6);
            margin-bottom: j(34);
            background: #fff;
            width: j(178);
            height: j(178);
            border-radius: 50%;
            transform: translateY(-50%);
        }
        .base-info {
            font-weight: normal;
            margin-top: j(-184/2);
        }
        .info-name {
            font-size: j(32);
            color: #363c54;
        }
        .department {
            margin-top: j(17);
            font-size: j(28);
            color: #9b9da9;
        }
    }

    .mine-items-chunk {
        margin-top: j(30);
        margin-bottom: j(30);
        li.mine-item {
            position: relative;
            @extend %bb1;
            height: 64px;
            padding: 0 j(45);
            .item-icon {
                width: j(48);
                height: j(48);
            }
            .item-name {
                margin-left: j(30);
                font-size: j(32);
                color: #696d7f;
            }
            .item-arrow {
                display: inline-block;
                width: j(15);
                height: j(15);
                border-top: 1px solid #9b9da9;
                border-right: 1px solid #9b9da9;
                transform: rotate(45deg);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/mine/mine.vue